import { render, staticRenderFns } from "./MtrlCategoryManagePage.vue?vue&type=template&id=312ebea2&"
import script from "./MtrlCategoryManagePage.vue?vue&type=script&lang=js&"
export * from "./MtrlCategoryManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports